export function legacyStringToAddressPayload(line) {
    const t = line.trim();
    return { city: '', street: t, house: '' };
}
/** Локальное отображение без formattedLine (корзина / черновик). */
export function formatDeliveryLine(a) {
    if (!a)
        return '';
    const parts = [];
    if (a.city.trim())
        parts.push(a.city.trim());
    if (a.street.trim())
        parts.push(a.street.trim());
    if (a.house.trim())
        parts.push(`д. ${a.house.trim()}`);
    if (a.entrance?.trim())
        parts.push(`подъезд ${a.entrance.trim()}`);
    if (a.floor?.trim())
        parts.push(`эт. ${a.floor.trim()}`);
    if (a.apartment?.trim())
        parts.push(`кв. ${a.apartment.trim()}`);
    return parts.join(', ');
}
export function isStructuredAddressPayload(x) {
    if (!x || typeof x !== 'object')
        return false;
    const o = x;
    return typeof o.city === 'string' && typeof o.street === 'string' && typeof o.house === 'string';
}
/**
 * Строка для UI из ответа API или черновика. Не рендерит объект в React:
 * если formattedLine не строка, собираем строку из полей.
 */
/** Для доставки курьером: без парадной, этажа или квартиры адрес считается неполным (предупреждение перед оплатой). */
export function isDeliveryAddressIncomplete(a) {
    if (!a)
        return true;
    const e = a.entrance?.trim() ?? '';
    const f = a.floor?.trim() ?? '';
    const ap = a.apartment?.trim() ?? '';
    return !e || !f || !ap;
}
export function formatStructuredAddressDisplay(a) {
    if (!a)
        return '';
    const fl = a.formattedLine;
    if (typeof fl === 'string' && fl.trim())
        return fl.trim();
    if (!isStructuredAddressPayload(a))
        return '';
    return formatDeliveryLine(a);
}
